<template>
  <div>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editClient"
      title="EDIT CLIENT"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editClient: function() {
      this.params.context.componentParent.editClient(this.params.data);
    }
  }
};
</script>